import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import useEmblaCarousel from "embla-carousel-react";

import * as styles from "./styles.module.scss";

import MediaImg from "../media-img/component";
import SVG from "../svg/component";
import { formatNumber } from "../../utils";

const TestimonialCarousel = (props) => {
  const { slides } = props;

  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    containScroll: "trimSnaps",
    loop: true,
    skipSnaps: true
  });

  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const scrollPrev = useCallback(
    () => emblaApi && emblaApi.scrollPrev(selectedIndex - 1),
    [emblaApi]
  );

  const scrollNext = useCallback(
    () => emblaApi && emblaApi.scrollNext(selectedIndex + 1),
    [emblaApi]
  );

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
    setPrevBtnEnabled(emblaApi.canScrollPrev());
    setNextBtnEnabled(emblaApi.canScrollNext());
  }, [emblaApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
  }, [emblaApi, onSelect]);

  const handleEdgeClick = (isActiveSlide, isNextSlide) => {
    if (isActiveSlide) return null;
    if (isNextSlide) return scrollNext;
    else return scrollPrev;
  };

  return (
    <div className={classNames(`embla`, styles.embla, "py-7")}>
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {slides.map((slide, index) => {
            const isNextSlide =
              selectedIndex + 1 === slides.length ? index === 0 : selectedIndex + 1 === index;
            const isActiveSlide = selectedIndex === index;
            return (
              <div
                className={`embla__slide ${isNextSlide && "next_slide"} ${
                  selectedIndex === index && "active_slide"
                }`}
                key={index}
                onClick={!isActiveSlide ? handleEdgeClick(isActiveSlide, isNextSlide) : null}
                onKeyPress={!isActiveSlide ? handleEdgeClick(isActiveSlide, isNextSlide) : null}
                role={!isActiveSlide ? "button" : null}
                tabIndex={!isActiveSlide ? "0" : null}
              >
                <div className="embla__slide__inner">
                  <MediaImg
                    className="embla__slide__img"
                    media={{ data: true, ...slide.image.data.attributes }}
                  />
                  {slide.description && (
                    <div className="embla__slide__description">
                      <div className="embla__slide__description__icon">
                        <MediaImg media={{ data: true, ...slide.icon.data.attributes }} />
                      </div>
                      <p>{slide.description}</p>
                      <p className="embla__slide__product__cost bold">
                        ${formatNumber(slide.cost)}
                      </p>
                      <div className="embla__slide__product__used">
                        <p className="bold">Product Used: </p>
                        <a className="hyperlink" href={slide.product_url}>
                          {slide.product_name}
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="controls_container">
        <div className="buttons">
          <button
            className="embla__button embla__button--prev"
            onClick={scrollPrev}
            disabled={!prevBtnEnabled}
          >
            <SVG className="embla__button__svg path" name="arrow-left"></SVG>
          </button>

          <button
            className="embla__button embla__button--next"
            onClick={scrollNext}
            disabled={!nextBtnEnabled}
          >
            <SVG className="embla__button__svg right" name="arrow-right"></SVG>
          </button>
        </div>
      </div>
    </div>
  );
};
TestimonialCarousel.propTypes = {
  slides: PropTypes.array
};

export default TestimonialCarousel;
